export class Tip {
    id: number;
    title: string;
    text: string;
    bg_color: string;
    media: string;
    media_type: string;
}
